
<template lang="pug">
  .input.input--email(:class="inputClass")
    input(
      type="email",
      :placeholder="placeholder",
      v-model="currentValue",
      :disabled="disabled"
    )
    label(v-if="labelText") {{ labelText }}
</template>

<script>
  import TextInput from 'scripts/components/forms/TextInput.vue';
  
  export default {
    name: 'EmailInput',
    extends: TextInput
  };
</script>

<style scoped lang="scss">
</style>
